export enum SpaceVars {
  SpaceId = 'SpaceId',
  SpaceName = 'SpaceName',
  SpaceDimensions = 'SpaceDimensions',
  SpaceRate = 'SpaceRate',
  SpaceHasClimateControl = 'SpaceHasClimateControl',
  SpaceIsInside = 'SpaceIsInside',
  SpaceHasPower = 'SpaceHasPower',
  SpaceFloor = 'SpaceFloor',
  SpaceIsParking = 'SpaceIsParking',
  SpaceIsDriveUp = 'SpaceIsDriveUp',
  SpaceHasElevatorAccess = 'SpaceHasElevatorAccess',
  SpaceHasAlarm = 'SpaceHasAlarm',
  SpaceFeatures = 'SpaceFeatures'
}
